import { TICKER_TEXT } from "../config/brand";

export const Ticker = () => (
  <div className="ticker" data-testid="ticker-marquee" aria-hidden="true">
    <div className="ticker-track">
      {[0, 1].map((i) => (
        <span key={i} className="ticker-chunk">
          {TICKER_TEXT}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      ))}
    </div>
  </div>
);
